<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-gray"></i>
        WEB DUKA - Retail Management System
        <i class="fa fa-circle text-warning"></i>
      </h5>
      <Widget
        class="widget-auth mx-auto"
        title="<h3 class='mt-0'>Login to your Web App</h3>"
        customHeader
      >
        <p class="widget-auth-info">Use your email to sign in.</p>
        <form class="mt" @submit.prevent="login">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">{{errorMessage}}</b-alert>
          <div class="form-group">
            <input
              class="form-control no-border"
              ref="username"
              required
              type="text"
              name="username"
              placeholder="Username"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control no-border"
              ref="password"
              required
              type="password"
              name="password"
              placeholder="Password"
            />
          </div>
          <b-button type="submit" size="sm" class="auth-btn mb-3" variant="inverse">Login</b-button>
        </form>
        <p class="widget-auth-info">Don't have an account? Sign up now!</p>
        <router-link class="d-block text-center" to="register">Create an Account</router-link>
      </Widget>
    </b-container>
    <footer class="auth-footer">2019 &copy; WebDuka Point of Sale and Retail Management System.</footer>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import userApi from "@/services/userApi";
import axios from "axios";

export default {
  name: "LoginPage",
  components: { Widget },
  data() {
    return {
      errorMessage: null
    };
  },
  methods: {
    login() {
      const username = this.$refs.username.value;
      const password = this.$refs.password.value;

      userApi
        .login(username, password)
        .then(response => {
          this.errorMessage = null;
          window.localStorage.setItem("authenticated", true);
          window.localStorage.setItem(
            "access_token",
            response.data.access_token
          );
          window.localStorage.setItem(
            "refresh_token",
            response.data.refresh_token
          );

          // intercept all headers

          axios.defaults.headers.common["Authorization"] =
            "Bearer " + window.localStorage.getItem("access_token");
          axios.defaults.headers.common["Content-Type"] =
            "application/x-www-form-urlencoded; charset=utf-8";
          this.$router.push("/app/dashboard");
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.errorMessage = "Invalid login details";
            } else {
              this.errorMessage =
                "An error occured. Please contact your system admin";
            }
          }
        });
    }
  },
  created() {
    if (window.localStorage.getItem("authenticated") === "true") {
      this.$router.push("/app/main/analytics");
    }
  }
};
</script>